// Page-view tracking for usage analytics. Sends only the page *path*, with
// ids replaced by ":id" — never the query string or #fragment (sign-in
// redirects carry user details there). Batched and sent every 15 s and when
// the tab is hidden or closed.

const API_BASE = import.meta.env.VITE_API_URL || '/api';
const ID_SEGMENT = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|\d+|[A-Za-z0-9_-]{17,})$/i;
const MAX_BATCH = 50;

const queue = [];
let lastPath = null;
let started = false;

export const normalisePath = (pathname) =>
    (pathname || '/').split('/').map(s => (ID_SEGMENT.test(s) ? ':id' : s)).join('/').replace(/\/+$/, '') || '/';

export const flushPageViews = () => {
    if (!queue.length) return;
    const body = JSON.stringify({ events: queue.splice(0, MAX_BATCH) });
    const url = `${API_BASE}/usage/events`;
    const headers = { 'Content-Type': 'application/json' };
    // Same dev-only identity header the API client sends (ignored in production).
    try {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        if (user?.email) headers['x-mock-user-email'] = user.email;
    } catch { /* no user */ }
    fetch(url, { method: 'POST', keepalive: true, credentials: 'include', headers, body })
        .catch(() => {
            // Last resort while the page unloads.
            try { navigator.sendBeacon?.(url, new Blob([body], { type: 'text/plain' })); } catch { /* give up */ }
        });
};

const start = () => {
    if (started || typeof window === 'undefined') return;
    started = true;
    setInterval(flushPageViews, 15000);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flushPageViews(); });
    window.addEventListener('pagehide', flushPageViews);
};

/** Record a page view for a signed-in user (repeat views of the same page are ignored). */
export const trackPageView = (pathname) => {
    if (!localStorage.getItem('isAuthenticated')) return;
    const path = normalisePath(pathname);
    if (path === lastPath) return; // re-renders, StrictMode double effects
    lastPath = path;
    start();
    queue.push({ path, at: Date.now() });
    if (queue.length >= 20) flushPageViews();
};
